import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { DotDelimeter } from '../../../Zemplin/General/DotDelimeter';
import { StoresInfoCartPopup } from '../../../Zemplin/Product/StoresInfoCartPopup';

interface Props {
  customNr: string;
  stockReadable: string;
  textColor?: string;
  availText?: string;
  storesInfo?: any;
  unit: string;
}

function CustomNrStock({
  customNr,
  stockReadable,
  textColor,
  availText,
  storesInfo,
  unit,
}: Props) {
  return (
    <Wrapper>
      {customNr && <CustomNr>{customNr}</CustomNr>}
      {stockReadable && customNr && <DotDelimeter />}
      {stockReadable && (
        <StockReadable color={textColor}>{stockReadable}</StockReadable>
      )}
      {availText
        ? availText !== 'Skladom' && (
            <StoresInfoCartPopup
              unit={unit}
              isAvailable={availText !== 'Nedostupné'}
              storesInfo={storesInfo}
              leftPosition={availText !== 'Nedostupné' ? '-47px' : '-62px'}
            />
          )
        : null}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)``;

const Text = styled(TextP)`
  font-family: ${({ theme }) => theme.font.tertiary};
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  white-space: nowrap;
`;

const CustomNr = styled(Text)`
  color: ${({ theme }) => theme.colors.placeholder};
`;
const StockReadable = styled(Text)<{ color: string }>`
  color: ${({ color }) => color};
`;

export { CustomNrStock };
